/*
Flexible Materials
  --bend <float> | inches | ('Inches of Bend')
  --coreType <string::combobox>
  --insideRadius <float> | inches
  --outsideRadius <float> | inches
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
*/
import { decimal } from 'vuelidate/lib/validators'

import {
  certification,
  computerEaseNumber,
  length,
  manufacturer,
  manufacturerNumber,
  name,
  thickness,
  width
} from '@/modules/standardItems/schemas/baseFormFields'

export default [
  name(),
  thickness({ classes: ['xs12', 'sm4', 'input--medium'], autofocus: true }),
  width({ classes: ['xs12', 'sm4', 'input--medium'] }),
  length({ classes: ['xs12', 'sm4', 'input--medium'] }),
  certification({ classes: ['xs12', 'sm6'] }),
  {
    key: 'coreType',
    value: 'coreType',
    type: 'combobox',
    source: 'coreTypes/coreTypeNames',
    fetch: 'coreTypes/get',
    classes: ['xs12', 'sm6'],
    attributes: {
      label: 'Core Type',
      class: ['input--dense']
    },
    saveOptions: {
      createAction: 'coreTypes/add',
      createMap: [{
        set: 'name'
      }],
      existingGetter: 'coreTypes/coreTypeByName',
      existingGetterParameter: 'name',
      newGetter: 'coreTypes/coreType',
      saveNew: true,
      saveMap: [
        {
          get: 'name',
          set: 'coreType'
        },
        {
          get: 'id',
          set: 'coreTypeID'
        }
      ]
    },
    trackUpdates: ['coreType', 'coreTypeID']
  },
  manufacturer({ classes: ['xs12', 'sm6'] }),
  manufacturerNumber({ classes: ['xs12', 'sm6'] }),
  computerEaseNumber(),

  {
    key: 'bend',
    value: 'bend',
    type: 'float',
    classes: ['xs12', 'sm4', 'input--medium'],
    attributes: {
      label: 'Bend',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  },
  {
    key: 'insideRadius',
    value: 'insideRadius',
    type: 'float',
    classes: ['xs12', 'sm4', 'input--medium'],
    attributes: {
      label: 'Inside Radius',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  },
  {
    key: 'outsideRadius',
    value: 'outsideRadius',
    type: 'float',
    classes: ['xs12', 'sm4', 'input--medium'],
    attributes: {
      label: 'Outside Radius',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  }
]
